import { Select } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { useFilterReferenceList } from './FilterReferenceList.hooks';
import { messages } from './FilterReferenceList.messages';
import { FilterReferenceListProps } from './FilterReferenceList.types';

export const FilterReferenceList = memo<FilterReferenceListProps>((props) => {
    const { value, options, isLoading, handleOpen, handleChange, handleInputChange } = useFilterReferenceList(props);

    return (
        <Select
            multiple
            itemIdKey='id'
            itemNameKey='text'
            value={value}
            size='small'
            progress={isLoading}
            items={options}
            onChange={handleChange}
            onInputChange={handleInputChange}
            onOpen={handleOpen}
            placeholder={messages.placeholder}
            autocomplete
        />
    );
});

FilterReferenceList.displayName = 'FilterReferenceList';
